<template>
  <div id="app" v-if="!loader">
      <router-view/>
  </div>
  <div v-else class="init-main">
    <img :src="logo" class="logo">
    <h4 class="text-white">Arus Explorer</h4>
  </div>
</template>
<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application.
   */
  import { createNamespacedHelpers } from 'vuex';
  import Header from './views/components/Header';
  import logo from './assets/images/logo_white.svg';
  import Footer from './views/components/Footer';

  const { mapState, mapActions } = createNamespacedHelpers('core');

  export default {
    /**
     * The name of the application.
     */
    name: 'VueBoilerplate',
    components: {
      Footer,
      Header
    },
    methods: {
      ...mapActions(['currency_get_rate'])
    },
    data: function () {
      return {
        loader: true,
        logo: logo
      };
    },
    mounted() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading ...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.5)'
      // });
      this.currency_get_rate(() => {
        this.loader = false;
        // loading.close()
      });
    }

    /**
     * Fires when the app has been mounted.
     */
  };
</script>
<style lang="scss" scoped>
  .init-main {
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .logo {
    margin-bottom: 20px;
  }
</style>
